export function requestResolver(promise) {
  return promise
    .then((res) => {
      const data = res?.data

      if (data && 'data' in data) {
        return data.data
      }

      if (data && 'dados' in data) {
        return data.dados
      }

      return data
    })
    .catch((err) => {
      const data = err?.response?.data
      const formattedError = new Error()

      if (data) {
        const errorMessage = data.message || data.erro

        if (errorMessage) {
          formattedError.message = errorMessage.includes('prisma')
            ? 'Something went wrong.'
            : errorMessage
        }

        formattedError.responseData = data
        formattedError.status = err?.response?.status
      }

      throw formattedError
    })
}
